import { OrderType } from 'types';

export const SAVE_BDO_STATEMENT_COMMAND_TYPE = 'SaveBdoStatement';

export interface SaveBdoStatementCommand {
	orderId: number;
	orderType: OrderType.classic | OrderType.loose;
	wasteCode: string;
	wasteName: string;
	pickupAddress: string;
	companyName: string;
	registeredAddress: string;
	nipPesel: string;
	signedPlace: string;
	signedDate: string;
}
